import { NgModule } from "@angular/core";

import {
    MatIconModule,
    MatSidenavModule,
    MatMenuModule,
    MatGridListModule,
    MatToolbarModule,
    MatListModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatOptionModule,
    MatSelectModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatStepperModule,
    MatCardModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatTabsModule,
    MatSliderModule,
    MatSlideToggle,
    MatSlideToggleModule
} from "@angular/material";
import { MaterialTimeControlModule } from "../timer/material-time-control.module";
import { MatSelectSearchModule } from "../mat-select-search/mat-select-search.module";

@NgModule({
    imports: [
        MatIconModule,
        MatSidenavModule,
        MatMenuModule,
        MatGridListModule,
        MatToolbarModule,
        MatListModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatOptionModule,
        MatSelectModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDividerModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatStepperModule,
        MatCardModule,
        MatSelectSearchModule,
        MaterialTimeControlModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatTabsModule,
        MatSliderModule,
        MatSlideToggleModule
    ],
    exports: [
        MatIconModule,
        MatSidenavModule,
        MatMenuModule,
        MatGridListModule,
        MatToolbarModule,
        MatListModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatOptionModule,
        MatSelectModule,
        MatProgressBarModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDividerModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatStepperModule,
        MatCardModule,
        MatSelectSearchModule,
        MaterialTimeControlModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatTabsModule,
        MatSliderModule,
        MatSlideToggleModule
    ]
})
export class MaterialModule { }